import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { roleHomePath, VIEWER_ROLES } from "@/lib/constants";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CitizenHome from "@/pages/CitizenHome";
import NewComplaint from "@/pages/NewComplaint";
import ComplaintDetail from "@/pages/ComplaintDetail";
import TrackComplaint from "@/pages/TrackComplaint";
import OfficerComplaints from "@/pages/OfficerComplaints";
import Dashboard from "@/pages/Dashboard";
import Reports from "@/pages/Reports";
import AdminPanel from "@/pages/AdminPanel";
import { ControlRoomHome } from "@/pages/ControlRoom";

function RoleHome() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  return <Navigate to={roleHomePath(user.role)} replace />;
}

export default function App() {
  const officerRoles = ["pi", "acp", "dcp", "additional_cp", "control_room", ...VIEWER_ROLES];
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/track" element={<TrackComplaint />} />
          <Route path="/home" element={<RoleHome />} />

          <Route path="/citizen" element={<ProtectedRoute roles={["citizen"]}><CitizenHome /></ProtectedRoute>} />
          <Route path="/citizen/new" element={<ProtectedRoute roles={["citizen"]}><NewComplaint /></ProtectedRoute>} />
          <Route path="/citizen/:id" element={<ProtectedRoute roles={["citizen"]}><ComplaintDetail /></ProtectedRoute>} />

          <Route path="/complaint/:id" element={
            <ProtectedRoute roles={officerRoles}><ComplaintDetail /></ProtectedRoute>
          } />

          <Route path="/pi" element={<ProtectedRoute roles={["pi"]}><OfficerComplaints scope="pi" /></ProtectedRoute>} />
          <Route path="/acp" element={<ProtectedRoute roles={["acp"]}><OfficerComplaints scope="acp" /></ProtectedRoute>} />
          <Route path="/dcp" element={<ProtectedRoute roles={["dcp"]}><OfficerComplaints scope="dcp" /></ProtectedRoute>} />
          <Route path="/additional-cp" element={<ProtectedRoute roles={["additional_cp"]}><OfficerComplaints scope="additional_cp" /></ProtectedRoute>} />

          <Route path="/control-room" element={<ProtectedRoute roles={["control_room"]}><ControlRoomHome /></ProtectedRoute>} />
          <Route path="/control-room/register" element={<ProtectedRoute roles={["control_room"]}><NewComplaint controlRoomMode /></ProtectedRoute>} />

          <Route path="/dashboard" element={
            <ProtectedRoute roles={["dcp", "additional_cp", "control_room", ...VIEWER_ROLES]}>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/reports" element={
            <ProtectedRoute roles={["dcp", "additional_cp", "control_room", ...VIEWER_ROLES]}>
              <Reports />
            </ProtectedRoute>
          } />

          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminPanel /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
